import { ExerciseTextArea, Typeform, Vimeo } from "@swizec/gatsby-theme-course-platform";
import * as React from 'react';
export default {
  ExerciseTextArea,
  Typeform,
  Vimeo,
  React
};